import Tabs from 'new-components/atoms/Tabs'
import { useHistory, useLocation } from 'react-router'

export const PRIVACY_POLICY_PATH = '/politica-de-privacidade'
export const TERMS_OF_USE_PATH = '/termos-de-uso'

const LEGAL_TABS = [
  { label: 'Política de privacidade', value: PRIVACY_POLICY_PATH },
  { label: 'Termos de uso', value: TERMS_OF_USE_PATH }
]

/**
 * Alterna entre os dois documentos legais. A aba ativa vem do pathname, então deep link,
 * F5 e o canonical do SEO de cada página continuam válidos.
 */
function LegalDocsTabs() {
  const history = useHistory()
  const { pathname } = useLocation()

  const handleValueChange = (value: string | undefined) => {
    if (value && value !== pathname) history.push(value)
  }

  return <Tabs className="mb-6 mt-4" tabs={LEGAL_TABS} value={pathname} onValueChange={handleValueChange} />
}

export default LegalDocsTabs
